import AddTenantDialog from "./AddTenantDialog";
import Tenants from "./Tenants";

export { Tenants, AddTenantDialog };
